import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  getRefCompIdFromInflatedId,
  getUniqueId,
  REF_DELIMITER,
} from '@wix/thunderbolt-commons/dist/refUtils';
import { MultiStateBoxDefinition } from '@wix/thunderbolt-components/src/components/MultiStateBox/MultiStateBox';
import { IMultiStateBoxPlatformProps } from '../MultiStateBox.types';

// When MSB is inside a Master, we need to infer the state ids of the slave instance
const getSlaveStateId = (stateId: string | undefined, msbId: string) => {
  if (!stateId) {
    return undefined;
  }
  // Already formatted
  if (stateId.includes(REF_DELIMITER)) {
    return stateId;
  }
  const refId = getRefCompIdFromInflatedId(msbId);
  return getUniqueId(refId, stateId);
};

export const props = withCompInfo<
  IMultiStateBoxPlatformProps,
  MultiStateBoxDefinition,
  IMultiStateBoxPlatformProps
>()(['compId'], ({ compId }, carmiData) => {
  const isInMaster = compId.includes(REF_DELIMITER);
  const selectedStateId = isInMaster
    ? getSlaveStateId(carmiData.selectedStateId, compId)
    : carmiData.selectedStateId;

  return {
    ...carmiData,
    selectedStateId,
  };
});

export default createComponentMapperModel({ props });
